import { Path, Rectangle, Shape } from "paper";
import { addEdgeLips, breakPath, mirrorX, setDefaultStyle } from "../../draw";
import { P, Segments } from "../common";
export class BoilingTube {
    render(appearance) {
        let width = appearance.width;
        let height = appearance.height;
        let graphic = new Path();
        graphic.addSegments(Segments([[0, 0]], [[0, height - width / 2], undefined, [0, width / 1.55]]));
        mirrorX(graphic, width / 2);
        addEdgeLips(graphic, { lipSize: 2.0 });
        let liquidMask = graphic.clone();
        setDefaultStyle(graphic);
        var hitShape = Shape.Rectangle(new Rectangle(0, 0, width, height));
        return {
            graphic: graphic,
            hitShape: hitShape,
            liquidMask: liquidMask,
            liquidMaskOpening: { start: P(0, 0), end: P(width, 0) },
            snapping: [
                { type: "neck", top: P(width / 2, 0), diameter: width, facing: 0 }
            ]
        };
    }
}
BoilingTube.properties = {
    label: "Boiling tube",
    canContainLiquids: true,
    meniscus: true,
    pourable: true,
    defaultAppearance: {
        width: 40,
        height: 180,
    },
    appearanceSpecs: [
        {
            spec: "slider",
            key: "width",
            label: "Width",
            min: 20,
            max: 60,
        },
        {
            spec: "slider",
            key: "height",
            label: "Height",
            min: 75,
            max: 300,
        },
    ]
};
export class BoilingTubeWithSideArm {
    render(appearance) {
        let width = appearance.width;
        let height = appearance.height;
        let offset = 30;
        let holeRadius = appearance.holeDiameter / 2;
        let sideArmLength = 15;
        let tube = new Path();
        tube.addSegments(Segments([[0, 0]], [[0, height - width / 2], undefined, [0, width / 1.55]]));
        mirrorX(tube, width / 2);
        tube.insertSegments(3, Segments([[width, offset + holeRadius]], [[width + sideArmLength, offset + holeRadius]], [[width + sideArmLength, offset - holeRadius]], [[width, offset - holeRadius]]));
        addEdgeLips(tube, { lipSize: 2.0 });
        let liquidMask = tube.clone();
        let graphics = breakPath(tube, 6);
        setDefaultStyle(graphics);
        var hitShape = Shape.Rectangle(new Rectangle(0, 0, width + sideArmLength, height));
        return {
            graphic: graphics,
            hitShape: hitShape,
            liquidMask: liquidMask,
            snapping: [
                { type: "connectable", at: P(width + sideArmLength, offset), facing: 90, },
                { type: "neck", top: P(width / 2, 0), diameter: width, facing: 0 }
            ]
        };
    }
}
BoilingTubeWithSideArm.properties = {
    label: "Boiling Tube with side arm",
    canContainLiquids: true,
    flippable: true,
    defaultAppearance: Object.assign(Object.assign({}, BoilingTube.properties.defaultAppearance), { holeDiameter: 10 }),
    appearanceSpecs: [
        ...BoilingTube.properties.appearanceSpecs,
        {
            spec: "slider", key: "holeDiameter", label: "Hole diameter",
            min: 8, max: 20,
        }
    ],
};
